import {createSlice, Dispatch} from "@reduxjs/toolkit";
import {UserService} from "app/services";
import {errorMsg} from "app/utils/MessageUtils";
import {UpdateEmployeeTypes} from "app/types/service-types/EmployeeTypes";
import {fetchAllEmployeeUsers} from "./user-employees-list.slice";

interface UpdateUserStateParams {
  id: string;
  body: UpdateEmployeeTypes;
  onSuccess?: Function;
  onError?: Function;
}

export const updatePassword = (params: UpdateUserStateParams) => async (dispatch: Dispatch) => {
  try {
    dispatch(setLoading(true));
    const response = await UserService.updateUserPassword(params.id, params.body);
    if (response.status >= 200 && response.status < 300) {
      dispatch(setSuccess(true));
     // dispatch(successMsg('Punonjesi u ndryshua me sukses!'));
      if (params.onSuccess) params.onSuccess();
      dispatch(setError(''));
      // @ts-ignore
      dispatch(fetchAllEmployeeUsers());
    }
    dispatch(setLoading(false));
  } catch (err) {
    dispatch(setLoading(false));
    dispatch(errorMsg(err.data.message));
    if (params.onError) params.onError();
    dispatch(setError(err.data.message));
  }
}

interface DeleteUserSlice {
  success: boolean;
  error: string;
  loading: boolean;
}

const initialState: DeleteUserSlice = {
  error: '',
  success: false,
  loading: false
}

const stateSlice = createSlice({
  name: 'users/update-user-password',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload
    },
    setSuccess: (state, action) => {
      state.success = action.payload
    },
    setError: (state, action) => {
      state.error = action.payload
    }
  }
});

export const {setLoading, setSuccess, setError} = stateSlice.actions;

export default stateSlice.reducer;